<template>
  <template v-if="shift.schedule && shift.schedule.length > 0">
    <div
      v-for="(schedule, index) in filteredSchedule"
      :key="index"
      class="schedule"
      :style="getFlexboxOrderStyleFromTimeAndDate(schedule.startTime)"
    >
      <span
        class="time"
        @click="$emit('click', schedule)"
        @keypress.enter="$emit('click', schedule)"
      >
        {{ getScheduleTime(schedule) }}
      </span>
      <span class="badge rounded-pill border border-primary text-bg-light ms-1">
        {{ schedule.type }}
      </span>
      <span class="notes">
        {{ schedule.notes }}
      </span>
    </div>
  </template>
</template>

<script>
import { computed } from "vue";
import filter from "lodash/filter";
import get from "lodash/get";
import {
  combineDateAndTime,
  parseTimeAsDateObject,
  formatTimeStringForHtmlInput,
  getFlexboxOrderStyleFromTime,
} from "../../../lib/date-functions";

export default {
  name: "RotaShiftScheduleView",
  components: {},
  props: {
    shift: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        showCareSchedule: true,
        showBreakSchedule: true,
      }),
    },
  },
  emits: ["click"],
  setup(props) {
    const getFlexboxOrderStyleFromTimeAndDate = (time) => {
      return getFlexboxOrderStyleFromTime(
        combineDateAndTime(props.shift.startDate, parseTimeAsDateObject(time)),
      );
    };

    const getScheduleTime = (schedule) => {
      return `${formatTimeStringForHtmlInput(
        schedule.startTime,
      )} - ${formatTimeStringForHtmlInput(schedule.endTime)}`;
    };

    const filteredSchedule = computed(() => {
      return filter(get(props.shift, "schedule", []), (schedule) => {
        if (props.options.showCareSchedule && schedule.type === "care") {
          return true;
        }
        if (props.options.showBreakSchedule && schedule.type === "break") {
          return true;
        }
        return false;
      });
    });

    return {
      getFlexboxOrderStyleFromTimeAndDate,
      getScheduleTime,
      filteredSchedule,
    };
  },
};
</script>

<style lang="scss">
.schedule {
  margin-bottom: 0.25em;
  span.time {
    font-weight: normal;
    text-decoration: underline;
    cursor: pointer;
  }

  .badge {
    margin-right: 0.25em;
    white-space: initial;
    font-weight: var(--bs-body-font-weight);
  }
}
</style>
